import { UpdateFlyerScraperSourceDto } from "@swagger/typescript-fetch-goflyer";
import {
  sanitizeScrapePromptConfigOverride,
  validateScrapePromptConfigOverride,
} from "./sanitizeScrapePromptConfigOverride";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { messages } from "../../../locales/messages";
import { adminApiService } from "../../../utils/api";
import i18n from "i18next";
import { useLoading } from "../../../contextApi/LoadingContext";
import { useNavigate } from "react-router-dom";
import { GoFlyerAdminContext } from "../../../contextApi/context";
import { useContext } from "react";

export const useHandleSaveFlyerScraper = () => {
  const { state } = useContext(GoFlyerAdminContext);
  const navigate = useNavigate();
  const { showLoadingScreen } = useLoading();
  const handleSaveFlyer = async (
    updateFlyerScraper?: UpdateFlyerScraperSourceDto,
  ) => {
    if (!updateFlyerScraper?.url) {
      toastError(`${i18n.t(messages.URL())} ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateFlyerScraper?.backupUrl) {
      toastError(
        `${i18n.t(messages.BackURL())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }

    if (!updateFlyerScraper?.stores && !updateFlyerScraper?.merchant) {
      toastError(
        `${i18n.t(messages.Stores())} ${i18n.t(messages.Merchants())} ${i18n.t(
          messages.is_Empty(),
        )}`,
      );
      return;
    }
    if (!updateFlyerScraper?.flyerTag) {
      toastError(
        `${i18n.t(messages.Flyer_Tag())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }

    if (!state.gfAdminUser) {
      toastError(
        `${i18n.t(messages.There_is_an_error_please_Contact_Administrator())}`,
      );
      return;
    }

    if (updateFlyerScraper?.scrapeTimes?.length) {
      for (const scrapeTime of updateFlyerScraper.scrapeTimes) {
        if (!/^\d{4}$/.test(scrapeTime.time)) {
          toastError(
            `Invalid time format: ${scrapeTime.time}, Please Follow HHmm format`,
          );
          return;
        }
      }
    }

    const overrideValidationError = validateScrapePromptConfigOverride(
      updateFlyerScraper.scrapePromptConfigOverride,
    );
    if (overrideValidationError) {
      toastError(overrideValidationError);
      return;
    }

    const cleanedOverride = sanitizeScrapePromptConfigOverride(
      updateFlyerScraper.scrapePromptConfigOverride,
    );

    showLoadingScreen(true);
    updateFlyerScraper.id
      ? await adminApiService.updateOneBaseFlyerScraperSourceAdminControllerFlyerScraperSource(
          {
            ...updateFlyerScraper,
            interval: updateFlyerScraper?.interval || 0,
            flippMerchant: updateFlyerScraper.flippMerchant || (null as any),
            aiScrapeEnabled: !!updateFlyerScraper.aiScrapeEnabled,
            scrapePromptConfigOverride: cleanedOverride ?? (null as any),
            scrapeMode: updateFlyerScraper.scrapeMode ?? (null as any),
          },
          updateFlyerScraper.id,
        )
      : await adminApiService.createOneBaseFlyerScraperSourceAdminControllerFlyerScraperSource(
          {
            ...updateFlyerScraper,
            url: updateFlyerScraper.url,
            backupUrl: updateFlyerScraper.backupUrl,
            interval: updateFlyerScraper?.interval || 0,
            scrapeTimes: updateFlyerScraper.scrapeTimes || [],
            provinces: updateFlyerScraper.provinces || [],
            stores: updateFlyerScraper.stores,
            merchant: updateFlyerScraper.merchant,
            flyerTag: updateFlyerScraper.flyerTag,
            adminUser: state.gfAdminUser,
            aiScrapeEnabled: updateFlyerScraper.aiScrapeEnabled ?? false,
            scrapePromptConfigOverride: cleanedOverride,
            scrapeMode: updateFlyerScraper.scrapeMode,
          },
        );
    showLoadingScreen(false);
    toastSuccess(i18n.t(messages.FlyerScraperSourceUploadedSuccessfully()));
    navigate(-1);
  };
  return handleSaveFlyer;
};
